import { renderSections } from './global.js';

if (!customElements.get('upsell-item')) {
  customElements.define(
    'upsell-item',
    class UpsellItem extends HTMLElement {
      constructor() {
        super();

        this.CLASSES = {
          buttonLoadingClass: 'button--is-loading',
        };

        /**
         * @type {HTMLButtonElement | null}
         */
        this.button = this.querySelector('.upsell-item__cta');
        this.button?.addEventListener('click', this.addToCartHandler.bind(this));

        this.select = this.querySelector('select');
        this.select?.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();

        this.toggleAddButton(false);

        if (!this.currentVariant) {
          this.toggleAddButton(true);
        } else {
          this.updatePrice();
          this.updateVariantInput();
        }

        console.log('onVariantChange', this.currentVariant);
      }

      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (element) => {
          return element.value;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateVariantInput() {
        /**
         * @type {HTMLInputElement | null}
         */
        const input = this.querySelector('input[name="id"]');

        if (!input) return;

        input.value = this.currentVariant.id;
      }

      updatePrice() {
        const priceEl = this.querySelector('[js-upsell-item-price]');

        if (!priceEl) return;
        priceEl.textContent = Shopify.formatMoney(this.currentVariant.price).replace(',00', '').replace('.00', '');
      }

      /**
       * @param {Boolean} disable
       */
      toggleAddButton(disable = true) {
        if (this.currentVariant.available) {
          this.button?.removeAttribute('disabled');
        } else {
          this.button?.setAttribute('disabled', 'disabled');
        }
      }

      getVariantData() {
        const varianDataEl = this.querySelector(`[id="item-variants-data-${this.itemId}"]`);

        if (!varianDataEl) return;

        this.variantData = this.variantData || JSON.parse(varianDataEl.textContent ?? '') || '';

        return this.variantData;
      }

      addToCartHandler() {
        const body = JSON.stringify({
          id: this.variantId,
          quantity: 1,
          sections: this.sectionsToRender.map((section) => section.section),
          sections_url: window.location.pathname,
        });

        this.setLoadingButton();

        fetch(`${window.routes.cartAddUrl}`, { ...this.fetchConfig, ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.resetButton();
            } else {
              renderSections(this.sectionsToRender, response);

              this.resetButton();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setLoadingButton() {
        this.button?.setAttribute('disabled', 'disabled');
        this.button?.classList.add(this.CLASSES.buttonLoadingClass);
      }

      resetButton() {
        this.button?.removeAttribute('disabled');
        this.button?.classList.remove(this.CLASSES.buttonLoadingClass);
      }

      get sectionsToRender() {
        return [
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.js-contents',
          },
          {
            id: 'main-cart-items',
            section: 'main-cart-items',
            selector: '.js-contents',
          },
          {
            id: 'main-cart-footer',
            section: 'main-cart-footer',
            selector: '.js-contents',
          },
        ];
      }

      get fetchConfig() {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/json` },
        };
      }

      get itemId() {
        return this.dataset.itemId;
      }

      get variantId() {
        /**
         * @type {HTMLInputElement | null}
         */
        const input = this.querySelector('input[name="id"]');

        return input ? input.value : false;
      }
    },
  );
}
